import { LandingPageGetDto, LandingPurposes } from "clearline-api";

/** @deprecated Use `LandingPageGetDto` interface instead */
export class LandingPage implements LandingPageGetDto {
  public id: number;
  public name: string;
  public publishedDate: string;
  public purpose: LandingPurposes;
  public content: string;
}

export enum LandingVariableType {
  Text = 1,
  Img = 2,
  Url = 3,
  ImgOrUrl = Img | Url
}
